import { useCallback, useContext, useLayoutEffect, useMemo, useState } from 'react';
import { assertIsDefined } from '@/helpers/assertions';
import { BannerContext } from '@/providers/BannerProvider/BannerContextProvider';
import { BANNER_HEIGHT_NUMERIC } from '@/components/Banner/Banner.styled';

export const useBannerManager = () => {
  const [bannerIds, setBannerIds] = useState<string[]>([]);

  const registerBanner = useCallback((id: string) => {
    setBannerIds(ids => (ids.includes(id) ? ids : [...ids, id]));

    return () => setBannerIds(ids => ids.filter(bannerId => bannerId !== id));
  }, []);

  const bannersOffset = bannerIds.length * BANNER_HEIGHT_NUMERIC;

  return { bannerIds, bannersOffset, registerBanner };
};

export const useBanners = () => {
  const { bannerIds, bannersOffset, registerBanner } = useContext(BannerContext);

  assertIsDefined(bannerIds, '"IBannerContext.bannerIds has to be defined!"');
  assertIsDefined(bannersOffset, '"IBannerContext.bannersOffset has to be defined!"');
  assertIsDefined(registerBanner, '"IBannerContext.registerBanner has to be defined!"');

  return { bannerIds, bannersOffset, registerBanner };
};

export const useRegisterBanner = (id: string) => {
  const { bannerIds, registerBanner } = useBanners();

  useLayoutEffect(() => registerBanner(id), [id, registerBanner]);

  return useMemo(() => Math.max(bannerIds.indexOf(id), 0), [bannerIds, id]);
};
